import { render, staticRenderFns } from "./LeaderEnroll.vue?vue&type=template&id=083e2d14&scoped=true&"
import script from "./LeaderEnroll.vue?vue&type=script&lang=js&"
export * from "./LeaderEnroll.vue?vue&type=script&lang=js&"
import style0 from "./LeaderEnroll.vue?vue&type=style&index=0&id=083e2d14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083e2d14",
  null
  
)

export default component.exports